import React, { createContext, useContext, useEffect, useState } from "react";
import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
const API = `${BACKEND_URL}/api`;

const DEFAULT_BRANDING = {
  club_name: "SHADOWS RECREATION CLUB",
  club_short_name: "SHADOWS",
  club_subtitle_ta: "உறுப்பினர் சேர்க்கை விண்ணப்பம்",
  club_tagline_ta: "( உறுப்பினர்கள் மட்டும் அனுமதி )",
  club_location: "Keernatham Village, Coimbatore - 641035",
  card_title: "MEMBER CARD",
  primary_color: "#0a1f5c",
  accent_color: "#c8a94a",
};

const BrandingContext = createContext(DEFAULT_BRANDING);

export function BrandingProvider({ children }) {
  const [branding, setBranding] = useState(DEFAULT_BRANDING);

  useEffect(() => {
    let cancelled = false;
    (async () => {
      try {
        const { data } = await axios.get(`${API}/branding`);
        if (!cancelled && data) setBranding({ ...DEFAULT_BRANDING, ...data });
      } catch (e) {
        if (process.env.NODE_ENV !== "production") console.error("Branding load failed:", e);
      }
    })();
    return () => { cancelled = true; };
  }, []);

  return (
    <BrandingContext.Provider value={branding}>
      {children}
    </BrandingContext.Provider>
  );
}

export function useBranding() {
  return useContext(BrandingContext);
}
